export default __webpack_public_path__ + "static/media/chatBuble.8766ad59.svg";